import { wrapIframes } from '../../../services/Util';
import styled from 'styled-components';

const StyledDiv = styled.div`
	a {
		text-decoration: underline;
	}
`;

export default function Editor({ content, id, className }) {
	if (!content || !content.length) {
		return false;
	}

	return (
		<StyledDiv
			id={id}
			className={className}
			dangerouslySetInnerHTML={{ __html: wrapIframes(content) }}
		></StyledDiv>
	);
}
